/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-04-12",
    versionChannel: "nightly",
    buildDate: "2025-04-12T00:06:37.754Z",
    commitHash: "284d2c694d59047e7345e7def48ce2c77de030d7",
};
